import { SearchIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/layout";
import { CloseButton, Input, InputGroup, InputLeftElement, InputRightElement } from "@chakra-ui/react";
import React from "react";

export const Search = ({ onSearch, searchQuery, autoFocus = false, isResults = false }) => {
  return (
    <InputGroup boxShadow={isResults && "0px 0px 7px rgba(0, 0, 0, 0.25)"} p={isResults ? '3px 20px' : 'auto'} alignItems="center">
      <InputLeftElement
        pointerEvents='none'
        position="relative"
        children={<SearchIcon />}
      />
      <Input p={0} ml="10px" autoFocus={autoFocus} value={searchQuery} onChange={ev => {
        if (ga) {
          ga('send', 'event', 'Search', 'click', 'Searching for phrase ' + '"' + ev.target.value + '"');
        }
        onSearch(ev.target.value);
      }
      } variant="unstyled" type="text" placeholder='Napisz czego szukasz' />
      {isResults && searchQuery?.length > 2 && <InputRightElement position="relative"
        onClick={() => onSearch('')}
        children={
          <Flex background="#D1E6FF" borderRadius="50%" justifyContent="center" alignItems="center" w="33px" h="33px">
            <CloseButton fontWeight="bold" />
          </Flex>
        }
      />}
    </InputGroup>
  )
}
